<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-flower-tulip" icon-small title="لیست درخواست وام ها" color="accent">
			<template v-slot:topActions>
				<v-btn color="primary" dark @click="add">
					<v-icon dark>
						mdi-plus-circle-outline
					</v-icon>
					ثبت درخواست جدید
				</v-btn>
				<v-btn color="primary" outlined small fab class="mx-1" @click="loadData()">
					<v-icon>
						mdi-refresh
					</v-icon>
				</v-btn>
			</template>
			<v-row>
				<v-col cols="12" style="padding:0 40px 40px">
					<v-row>
						<v-col cols="12" md="6">
							<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
						</v-col>
						<v-col cols="12">
							<v-data-table :headers="headers" :items="items" :loading="loading" :items-per-page="500" :search="search" class="elevation-1">
								<template v-slot:item.amount="{ item }">
									{{ item.amount.toString().toPriceFormat() }}
								</template>
								<template v-slot:item.requestDate_Persian="{ item }">
									&lrm;{{ `${item.requestDate_Persian.date} ${item.requestDate_Persian.time}` }}
								</template>
								<template v-slot:item.adminDescription="{ item }">
									{{ (item.adminDescription || '-') }}
								</template>
								<template v-slot:item.agentModel="{ item }">
									<div v-if="!item.agentModel">بدون نماینده</div>
									<div v-else>
										<div>
											<small>نماینده: </small> <small class="grey--text">{{ item.agentModel.businessName }}</small>
										</div>
										<div>
											<small>سررسید واریز به نماینده: </small>
											<small v-if="item.userLoan && item.userLoan.agentDueDate" class="grey--text">{{ item.userLoan.agentDueDate_Persian.date }}</small>
											<small v-else class="grey--text">-</small>
										</div>
									</div>
								</template>
								<template v-slot:item.operations="{ item }">
									<v-btn class="mx-1" fab dark small color="secondary" @click="edit(item)">
										<v-icon dark>
											mdi-square-edit-outline
										</v-icon>
									</v-btn>
									<v-btn class="mx-1" fab dark small color="pink" @click="remove(item)">
										<v-icon dark>
											mdi-trash-can-outline
										</v-icon>
									</v-btn>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
			<v-dialog v-model="dialog" scrollable persistent max-width="1000px">
				<v-card>
					<v-card-title>
						<span class="headline">درخواست وام</span>
						<v-spacer />
						<v-btn @click="dialog = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-container>
							<modify-request ref="modifyRequest" v-if="dialog" :data="selectedRequest" @callbck="callbck" />
						</v-container>
					</v-card-text>
				</v-card>
			</v-dialog>
		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { emptyId } from '@/util/emptyId'

	export default {
		name: 'LoanRequestsView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			ModifyRequest: () => import('./ModifyLoanRequest.vue'),
		},
		data() {
			return {
				errorMessages: '',
				localData: {},
				selectedRequest: {},
				loading: false,
				dialog: false,
				search: '',
				headers: [
					{
						text: 'شماره درخواست',
						align: 'start',
						sortable: true,
						value: 'code',
						width: 50
					}, {
						text: 'وام',
						align: 'start',
						sortable: true,
						value: 'loanModel.title',
					}, {
						text: 'مبلغ',
						align: 'center',
						sortable: true,
						value: 'amount',
					}, {
						text: 'تاریخ ثبت درخواست',
						align: 'center',
						sortable: true,
						value: 'requestDate_Persian',
					}, {
						text: 'وضعیت',
						align: 'center',
						sortable: true,
						value: 'str_Status',
					}, {
						text: 'اطلاعات نماینده',
						align: 'center',
						sortable: true,
						value: 'agentModel',
					}, {
						text: 'نظر کارشناس',
						align: 'start',
						sortable: true,
						value: 'adminDescription',
					}, {
						text: 'عملیات ها',
						align: 'center',
						sortable: false,
						width: 150,
						value: 'operations',
					},
				],
				items: [],
			}
		},
		mounted() {
			this.loadData()
			this.autoOpenModal()
		},
		methods: {
			autoOpenModal() {
				if (this.$route.params.id) {
					this.selectedRequest = { id: this.$route.params.id }
					this.dialog = true
				} else {
					let loanRequest_storage = window.localStorage.getItem("loanrequest")
					if (loanRequest_storage) {
						this.selectedRequest = JSON.parse(loanRequest_storage)
						this.selectedRequest.id = emptyId
						this.dialog = true
						localStorage.removeItem("loanrequest")
					}
				}
			},
			loadData() {
				this.loading = true
				api.get('member/userLoanRequest/list', null)
					.then(
						response => {
							this.items = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loading = false
					})
			},
			add() {
				this.dialog = true
				this.selectedRequest = { id: emptyId }
			},
			edit(item) {
				this.dialog = true
				this.selectedRequest = item
			},
			callbck(result) {
				if (result === 'close') {
					this.dialog = false
					return
				}
				if (result == 'refresh') {
					this.loadData()
					return
				}
				this.dialog = false
				if (result) { this.loadData() }
			},
			async remove(item) {
				if (!item) { return }

				if (await this.$refs.confirm.open(
					'توجه',
					'آیا از حذف این آیتم مطمئن هستید؟',
				)) {
					api.post('member/userLoanRequest/delete/' + item.id)
						.then(
							response => {
								toast.success('اطلاعات با موفقیت حذف شد.')
								this.loadData()
							})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
		},
	}
</script>
<style></style>
